export const EXAMPLE_DOMAIN_EMAIL = "support@yourcompany.com";

export const FOOTER_NOTE =
  "Each group can have its own domain for multi-brand support.";

export const REQUIREMENTS = [
  "Each group can have its own verified mail domain",
  "Add DNS records at your provider exactly as shown",
  "Validate DNS after records propagate (may take up to 48 hours)",
  "Business and personal email linking require a verified domain for that group",
];

export function getErrorMessage(payload) {
  if (!payload) return "Something went wrong";
  if (typeof payload === "string") return payload;
  return (
    payload.message ||
    payload.error ||
    (Array.isArray(payload.errors) && payload.errors[0]?.message) ||
    "Something went wrong"
  );
}
